import React from 'react';
import { NavigateFunction } from 'react-router-dom';

import s from './Header.module.scss';
import { ROUTE_PREFIX } from '../../constants/router';
import getAssetLink from '../../util/getAssetLink';
import { withRouter } from '../../util/withRouter';

interface HeaderProps {
  withBackButton?: boolean;
  backUrl?: string;
  onBack?: () => void;
  children?: React.ReactNode;
  navigate: NavigateFunction;
}

class Header extends React.Component<HeaderProps> {
  static defaultProps = {
    withBackButton: true,
    backUrl: `${ROUTE_PREFIX}/home`,
    onBack: null,
    children: null,
  };

  constructor(props: any) {
    super(props);
    this.renderBackButton = this.renderBackButton.bind(this);
  }

  renderBackButton() {
    return (
      <button
        type="button"
        className="btn-no-style"
        onClick={() => {
          if (this.props.onBack) {
            this.props.onBack();
          } else {
            this.props.navigate(this.props.backUrl as string);
          }
        }}
      >
        <img
          className={s.backButton}
          src={getAssetLink('back_button.png')}
          alt="back"
        />
      </button>
    );
  }

  render() {
    return (
      <div className={s.headerContainer}>
        <div className={s.backButtonWrapper}>
          {this.props.withBackButton && this.renderBackButton()}
        </div>
        <div className={s.middle}>{this.props.children}</div>
        <div className={s.logoWrapper}>
          <button
            type="button"
            className="btn-no-style"
            onClick={() => {
              this.props.navigate(`${ROUTE_PREFIX}/`);
            }}
          >
            <img
              className={s.logo}
              src={getAssetLink('AKLogo.png')}
              alt="logo"
            />
          </button>
        </div>
      </div>
    );
  }
}

export default withRouter(Header);
